module.exports = __webpack_public_path__ + "static/media/doctor400x300.7e122787.svg";